import type { GatewayConfig } from '@/core/api'
import type { LibraryStore } from '@/core/stores/libraries'
import { useLibraryStore } from '@/core/stores/librariesStore'

import type { GatewayUserSettings } from './interfaces/gatewayUserSettings.interface'
import { resolveGatewayRuntimePorts } from './resolveGatewayRuntimePorts'

interface SyncGatewayRuntimeOptions {
  config: GatewayConfig
  apiPorts: { websocketPort: string; mcpPort: string }
  gatewaySettings: GatewayUserSettings
  extraState?: Partial<LibraryStore>
}

export function syncGatewayRuntimeToLibraryStore({
  config,
  apiPorts,
  gatewaySettings,
  extraState,
}: SyncGatewayRuntimeOptions): void {
  const runtime = resolveGatewayRuntimePorts(config, apiPorts, gatewaySettings)

  useLibraryStore.setState({
    gatewayPath: runtime.gatewayPath,
    gatewayWsPort: runtime.gatewayWsPort,
    gatewayMcpPort: runtime.gatewayMcpPort,
    gatewayPort: config.port,
    isSecured: runtime.isSecured,
    ...extraState,
  })
}
